/**
 * @module タブヘッダー部共通コンポーネント
 */
export default {
  props: {
    marginBottom: {
      type: Number,
      default: 15,
      required: false,
    },
    tabNumber: {
      type: Number,
      default: 1,
      required: false,
    },
    tabList: {
      type: Array,
      default: [],
      required: true,
    },
    leftTitle: {
      type: String,
      default: '',
      required: false,
    },
    leftImage: {
      type: Object,
      required: false,
    },
    rightTitle: {
      type: String,
      default: '',
      required: false,
    },
    rightImage: {
      type: Object,
      required: false,
    },
  },
  computed: {
    localTabNumber: {
      get: function () {
        return this.tabNumber;
      },
      set: function (value) {
        this.$emit('result', value);
      },
    },
  },
  data: () => ({
    id: '',
  }),
  /** @type {Methods} */
  methods: {
    /**
     * タブ選択処理
     * @param {number} num 選択したタブ
     */
    selectTab(num) {
      this.localTabNumber = num;
    },
  },
};
